import { Component, OnDestroy, OnInit, Inject, Input } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';


export class WaitAndLoadComponent implements OnDestroy, OnInit {

    
    public dots : number;

    
    public currentDot : number;

    
    public isLoading : number;

    public dotsArray : Array<number>;

    constructor() {}

    ngOnInit() {
      this.dotsArray = Array(this.dots).fill(this.dots).map((x : any, i : any)=>i);;
    }

    ngOnDestroy() {

    }


static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: '[leaf-wait-and-load]',
  template:  `
  <div *ngIf="currentDot > 0 && !isLoading">
    <small>
    <i class="fa" *ngFor="let dot of dotsArray; let i = index;"
    style="padding-left: 4px;"
    [class.fa-circle]="(dots - i) >= currentDot"
    [class.fa-circle-thin]="(dots - i) < currentDot">
    </i>

    </small>
  </div>
  <div *ngIf="isLoading">
    <i class="fa fa-circle-o-notch fa-spin"></i>
  </div>
  `
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'dots': [{ type: Input },],
'currentDot': [{ type: Input },],
'isLoading': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
